
import { defineComponent, PropType } from "vue";
import { GroupedAlert, AlertType } from "@/stores/telegramAlerts";
import ForexAlertRow from "@/components/alerts/tables/ForexAlertRow.vue";

export default defineComponent({
  name: "ForexAlertsTable",
  components: {
    ForexAlertRow,
  },
  props: {
    alerts: {
      type: Array as PropType<GroupedAlert[]>,
      required: true,
    },
    alertType: {
      type: String, // "forex" or "synthetic_indices"
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    expandedAlertId: {
      type: Object as PropType<Set<string>>,
      required: true,
    },
    editingAlertId: String as PropType<string | null>,
    isSaving: Boolean,
    isReprocessing: Object as PropType<Record<number, boolean>>,
  },
  emits: [
    "toggle-expand",
    "start-edit",
    "cancel-edit",
    "save-edit",
    "reprocess-message",
  ],
  setup() {
    return {
      AlertType,
    };
  },
});
